var React = require('react');

function IconFilterDash (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M168.185 24.5H35.343c-3.207 0-4.971 3.688-2.966 6.173l46.338 58.124c1.684 2.164 2.646 4.81 2.646 7.536v75.761c0 2.164 2.566 3.207 4.089 1.684l33.431-33.03a5.398 5.398 0 0 0 1.604-3.848V97.214c0-2.806.962-5.452 2.725-7.616l10.101-12.426c2.164-2.725 1.684-6.734-1.202-8.739-2.566-1.844-6.093-1.363-8.098 1.123l-13.789 16.916a7.78 7.78 0 0 0-1.764 4.891v42.651c0 .16-.08.241-.16.321l-14.191 13.95a.463.463 0 0 1-.802-.321V90.641c0-1.764-.561-3.448-1.684-4.81L53.62 38.129c-.481-.641-.08-1.523.721-1.523h94.441c.802 0 1.282.962.721 1.523l-11.304 13.869c-2.164 2.725-1.684 6.734 1.202 8.739 2.566 1.844 6.093 1.363 8.098-1.123l23.65-28.862c2.006-2.484.242-6.252-2.964-6.252z"}));
}

IconFilterDash.displayName = "IconFilterDash";

IconFilterDash.defaultProps = {"viewBox":"0 0 200 200"};

module.exports = IconFilterDash;

IconFilterDash.default = IconFilterDash;
